import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { BmarkRiskData } from "shared/cubiq-services/model/benchmarks/BmarkRiskData.model";
import { ICellRendererParams } from "ag-grid-community";
import { ScratchPadOrder } from "shared/cubiq-services/model/orders/ScratchPadOrder";
import { BmarkOrderData } from "shared/cubiq-services/model/benchmarks/BmarkOrderData.model";

@Component({
  selector: "multialloc-product-renderer",
  template: `
    <div class="multialloc-product">
      <i *ngIf="isMultiAllocation" class="ionicons icon_ion_clone_filled"></i>
      <span>{{ productName }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultiAllocProductRenderer implements ICellRendererAngularComp {
  public isMultiAllocation: boolean = false;
  public productName: string;

  constructor(public cd: ChangeDetectorRef) {}

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    const order: ScratchPadOrder | BmarkOrderData = params.data;

    if (order.multiAllocation === this.isMultiAllocation && params.value === this.productName) {
      return false;
    }

    this.isMultiAllocation = order.multiAllocation;
    this.productName = params.value;
    return true;
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }
    return true;
  }
}
